import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CONFIGURE_DEFAULT_PARAMS, LoadGridPayload } from '@data-access/shared';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { organizationStudyListTokenizer } from '../store';

export const studyListResolver = (route: ActivatedRouteSnapshot) => {
  const _studySignalStore = organizationStudyListTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);
  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );
  const _payload: LoadGridPayload = {
    params: _params,
  };
  const id =
    route.paramMap.get('id') ?? route.parent?.data['contactId'] ?? '';
  _studySignalStore.setByURL(route.data.type ?? 'main', id);
  _studySignalStore.loadStudyGrid(_payload);

  return !!_studySignalStore.$studies();
};
